<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h2>Look & Feel</h2>
    </mat-card-title>
    <mat-card-subtitle>Changes are automatically saved to a draft copy of settings. View these changes by launching your NPC Preview.
    When everything looks good, make your draft settings live for students.</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content style="margin-top: 1rem;">
    @if (ups.draftChanges | async) {
      <div>
        <button mat-flat-button color="primary" (click)="publishPreferences()">Make Changes Live</button>
        <button mat-flat-button color="basic" style="margin-left:1rem" (click)="resetPreferences()">Discard Draft Changes</button>
      </div>
    } @else {
      No draft changes to apply
    }
  </mat-card-content>
</mat-card>
